import { useRouter } from 'vue-router';

/**
 * Default "Quay lại" (go back) behaviour for PDF viewer pages.
 *
 * PDF viewer pages are typically opened in a new browser tab (via
 * `window.open`), so the preferred action is to close the tab. When the page
 * was navigated to within the same tab it falls back to browser history, and
 * finally to an optional fallback route.
 */
export const usePdfViewerBack = (fallbackRouteName?: string) => {
  const router = useRouter();

  const goBack = () => {
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }

    if (window.history.length > 1) {
      router.back();
      return;
    }

    if (fallbackRouteName) {
      router.push({ name: fallbackRouteName });
    }
  };

  return { goBack };
};
